import type { ResultsApi } from "@/v2/api/metadata/results";
import type { SportsApi } from "@/v2/api/metadata/sports";
import type { BackofficeContext } from "@/v2/framework/context/types";
import type { DialogConfig } from "@/v2/framework/dialog/types";
import { readApiData } from "@/v2/api/response";
import { createFeedConfigTab } from "./tabs/feed-config";
import { createFeedMappingTab } from "./tabs/feed-mapping";
import { createConfigurationTab } from "./tabs/configuration";
import { limitsTab } from "./tabs/limits";
import { createLiveTab } from "./tabs/live";
import { createMainTab } from "./tabs/main";
import { createPrematchTab } from "./tabs/prematch";
import { createResultsMappingTab } from "./tabs/results-mapping";
import { createTranslationsTab } from "./tabs/translations";

export function createEditDialog(options: {
  ctx: BackofficeContext;
  sportsApi: SportsApi;
  resultsApi: ResultsApi;
}): DialogConfig {
  const { ctx, sportsApi, resultsApi } = options;

  return {
    id: "edit-sport",
    title: "Edit sport",
    layout: {
      type: "popover",
    },
    api: {
      initialValues: async (row) => {
        const response = await sportsApi.getSingle(row.id);
        const data = readApiData(response);
        return (data && typeof data === "object" && !Array.isArray(data) ? data : {}) as Record<
          string,
          unknown
        >;
      },
      submit: async () => {},
    },
    structure: {
      type: "tabbed",
      savePerTab: true,
      tabs: [
        createMainTab(sportsApi),
        createPrematchTab(sportsApi),
        createLiveTab(sportsApi),
        createTranslationsTab({ ctx, sportsApi }),
        createFeedMappingTab(sportsApi),
        createResultsMappingTab({ sportsApi, resultsApi }),
        limitsTab,
        createConfigurationTab({ sportsApi }),
        createFeedConfigTab(sportsApi),
      ],
    },
  };
}
